import { RootState } from '../redux';

export const selectIsRunning = (state: RootState) => state.experiments.isRunning;
export const selectIsCancelled = (state: RootState) => state.experiments.isCancelled;
export const selectExperimentId = (state: RootState) => state.experiments.experimentId;
export const selectRunIndex = (state: RootState) => state.experiments.runIndex;
export const selectHasRunExperiment = (state: RootState) => state.experiments.hasRunExperiment;